import { render, staticRenderFns } from "./ActivityBox.vue?vue&type=template&id=1b569104&scoped=true&"
import script from "./ActivityBox.vue?vue&type=script&lang=ts&"
export * from "./ActivityBox.vue?vue&type=script&lang=ts&"
import style0 from "./ActivityBox.vue?vue&type=style&index=0&id=1b569104&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b569104",
  null
  
)

/* custom blocks */
import block0 from "./ActivityBox.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports